import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const EditArticle = () => {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = () => {
    axios
      .get(`${API_URL}/api/posts`)
      .then((response) => {
        setPosts(response.data);
      })
      .catch((error) => {
        console.error("記事の取得に失敗しました", error);
      });
  };

  const handleNavigateToEdit = (id) => {
    navigate(`/dashboard/edit-article/${id}`);
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <div style={{ paddingLeft: '50px' }}>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mb-4 text-blue-600 hover:underline"
          style={{ display: "block", marginTop: "10px", marginBottom: "10px" }}
        >
          ← 前に戻る
        </button>
      </div>

      <hr className="border-t border-gray-300 my-4 w-full" />

      <div style={{ paddingLeft: "50px" }}>
        <h1>編集対象の記事一覧</h1>
        <p>タイトルをクリックして編集してください。</p>
        <ul>
          {posts.map((post) => (
            <li
              key={post.id}
              onClick={() => handleNavigateToEdit(post.id)}
              style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
            >
              {post.title}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default EditArticle;
